export default {
  'tour.name': 'اسم الجولة',
  'tour.en.name': 'اسم الجولة بالإنجليزية',
  'tour.en.fa.name': 'اسم الجولة بالفارسية',
  'tour.englishTourName': 'اسم الجولة (بالإنجليزية)',
  'tour.persianTourName': 'اسم الجولة (بالفارسية)',
  'tour.necessities': 'الضروريات بالإنجليزية',
  'tour.en.necessities': 'الضروريات بالإنجليزية',
  'tour.en.fa.necessities': 'الضروريات بالفارسية',
  'tour.englishNecessities': 'الضروريات اللازمة للسفر (بالإنجليزية)',
  'tour.persianNecessities': 'الضروريات اللازمة للسفر (بالفارسية)',
  'tour.moneyUnit': 'وحدة النقود',
  'tour.price': 'السعر',
  'tour.setPrice': 'تعيين السعر',
  'tour.type': 'نوع الجولة',
  'tour.registerDate': 'تاريخ التسجيل',
  'tour.whether': 'سواء',
  'tour.tourCondition': 'حالة الجولة',
  'tour.passengerTypes': 'أنواع الركاب',
  'tour.choosePassengerTypes': 'اختر أنواع الركاب',
  'tour.capacity': 'سعة عدد الأشخاص في الجولة',
  'tour.duration': 'مدة الجولة (أيام)',
  'tour.destination': 'الوجهة',
  'tour.destinationCity': 'مدينة الوجهة',
  'tour.destinationCountry': 'بلد الوجهة',
  'tour.en.destination': 'اسم الوجهة بالإنجليزية',
  'tour.en.fa.destination': 'اسم الوجهة بالفارسية',
  'tour.description': 'الوصف',
  'tour.en.description': 'الوصف بالإنجليزية',
  'tour.en.fa.description': 'الوصف بالفارسية',
  'tour.englishDescription': 'أذكر التفاصيل المطلوبة للرحلة (بالإنجليزية)',
  'tour.persianDescription': 'أذكر التفاصيل المطلوبة للرحلة (بالفارسية)',
  'tour.limitaions': 'القيود',
  'tour.en.limitaions': 'القيود بالإنجليزية',
  'tour.englishlimitaions': 'القيود على السفر (بالإنجليزية)',
  'tour.persianlimitaions': 'القيود على السفر (بالفارسية)',
  'tour.departure': 'المغادرة',
  'tour.departureCity': 'مدينة المغادرة',
  'tour.departureCountry': 'بلد المغادرة',
  'tour.en.departure': 'المغادرة',
  'tour.en.fa.departure': 'المغادرة بالفارسية',
  'tour.difficultyRate': 'صعوبة السفر',
  'tour.departureDate': 'وقت بدء الجولة',
  'tour.international': 'دولي',
  'tour.domestic': 'محلي',
  'tour.addTour': 'إضافة جولة جديدة',
  'tour.easy': 'سهل',
  'tour.amature': 'هاوي',
  'tour.normal': 'عادي',
  'tour.hard': 'صعب',
  'tour.veryHard': 'صعب جداً',
  'tour.road': 'طريق',
  'tour.flight': 'رحلة جوية',
  'tour.marine': 'بحري',
  'tour.transportTypes': 'أنواع النقل',
  'tour.chooseTransportTypes': 'اختيار أنواع النقل',
  'tour.surpriseTour': 'جولة مفاجئة',
  'tour.ordinaryTour': 'جولة عادية',
  'tour.next': 'الخطوة التالية',
  'tour.home': 'الصفحة الرئيسية',
  'tour.confirm': 'تأكيد',
  'tour.previous': 'الخطوة السابقة',
  'tour.active': 'نشط',
  'tour.disable': 'تعطيل',
  'tour.dollar': 'الدولار الأمريكي',
  'tour.euro': 'اليورو',
  'tour.rial': 'الريال الإيراني',
  'tour.stepOne': 'الخطوة 1',
  'tour.stepTwo': 'الخطوة 2',
  'tour.stepThree': 'الخطوة 3',
  'tour.stepFour': 'الخطوة 4',
  'tour.stepFive': 'الخطوة 5',
  'tour.details': 'التفاصيل',
  'tour.tourDetails': 'تفاصيل الجولة',
  'tour.cancel': 'إلغاء',
  'tour.chooseTourType': 'اختيار نوع الجولة',
  'tour.save': 'حفظ',
  'tour.tourDetail': 'معلومات الجولة',
  'tour.furtherInformation': 'معلومات إضافية',
  'tour.toddlerinownsitPrice': 'سعر الطفل الذي يجلس بمفرده',
  'tour.infantPrice': 'سعر الرضيع',
  'tour.childPrice': 'سعر الطفل',
  'tour.adultPrice': 'سعر البالغ',
  'tour.studentPrice': 'سعر الطالب',
  'tour.seniorcitizenPrice': 'سعر كبار السن',
  'tour.bookingDeadline': 'آخر موعد للتسجيل في الجولة',
  'tour.climateType': 'طقس أثناء الرحلة',
  'tour.step': 'الخطوة',
  'tour.tourclimateTitle': 'اختيار مناخ الجولة',
  'tour.tourclimateDescription': 'اختر نوع الطقس الذي تريده',
  'tour.tourtypeTitle': 'اختيار نوع الجولة',
  'tour.tourtypeDescription': 'حدد نوع الجولة التي تريدها',
  'tour.tourtransfertypeTitle': 'نوع نقل الجولة',
  'tour.tourtransfertypeDescription': 'حدد نوع نقل الجولة الذي تريده',
  'tour.tourpassengertypeTitle': 'نوع المسافرين في الجولة',
  'tour.tourpassengertypeDescription': 'حدد نوع المسافرين في الجولة الذي تريده',
  'tour.tourinformationTitle': 'معلومات الجولة',
  'tour.tourinformationDescription': 'أدخل معلومات الجولة الكاملة الخاصة بك',
  'tour.touroverviewTitle': 'نظرة عامة على الجولة',
  'tour.touroverviewDescription':
    'قم بمراجعة معلومات الجولة الخاصة بك وتحريرها حسب الحاجة',
  'tour.tourpriceTitle': 'سعر الجولة',
  'tour.overview': 'نظرة عامة',
  'tour.tourpriceDescription': 'أدخل الأسعار لكل مسافر من اختيارك',
  'tour.tourScheduling': 'جدولة الجولة',
  'tour.mainTourInformation': 'معلومات الجولة الرئيسية',
  'tour.tourConditions': 'شروط الجولة',
  'tour.tourRestrictionsRequirements': 'قيود ومتطلبات الجولة',
  'tour.tourRegistration': 'تسجيل الجولة',
  'tour.addNewTour': 'إضافة جولة جديدة',
  'tour.name': 'اسم الجولة',
  'tour.en.name': 'اسم الجولة بالإنجليزية',
  'tour.en.fa.name': 'اسم الجولة بالفارسية',
  'tour.englishTourName': 'اسم الجولة (بالإنجليزية)',
  'tour.persianTourName': 'اسم الجولة (بالفارسية)',
  'tour.necessities': 'الضروريات بالإنجليزية',
  'tour.en.necessities': 'الضروريات بالإنجليزية',
  'tour.en.fa.necessities': 'الضروريات بالفارسية',
  'tour.englishNecessities': 'الضروريات اللازمة للسفر (بالإنجليزية)',
  'tour.persianNecessities': 'الضروريات اللازمة للسفر (بالفارسية)',
  'tour.moneyUnit': 'وحدة العملة',
  'tour.price': 'السعر',
  'tour.setPrice': 'تحديد السعر',
  'tour.type': 'نوع الجولة',
  'tour.registerDate': 'تاريخ التسجيل',
  'tour.whether': 'سواء',
  'tour.tourCondition': 'شرط الجولة',
  'tour.passengerTypes': 'أنواع الركاب',
  'tour.choosePassengerTypes': 'اختيار أنواع الركاب',
  'tour.capacity': 'سعة عدد الأشخاص في الجولة',
  'tour.duration': 'مدة الجولة (أيام)',
  'tour.destination': 'الوجهة',
  'tour.destinationCity': 'مدينة الوجهة',
  'tour.destinationCountry': 'بلد الوجهة',
  'tour.en.destination': 'اسم الوجهة بالإنجليزية',
  'tour.en.fa.destination': 'اسم الوجهة بالفارسية',
  'tour.description': 'الوصف',
  'tour.en.description': 'الوصف بالإنجليزية',
  'tour.en.fa.description': 'الوصف بالفارسية',
  'tour.englishDescription': 'ذكر التفاصيل المطلوبة للرحلة (بالإنجليزية)',
  'tour.persianDescription': 'ذكر التفاصيل المطلوبة للرحلة (بالفارسية)',
  'tour.limitaions': 'القيود',
  'tour.en.limitaions': 'القيود بالإنجليزية',
  'tour.englishlimitaions': 'القيود على السفر (بالإنجليزية)',
  'tour.persianlimitaions': 'القيود على السفر (بالفارسية)',
  'tour.departure': 'المغادرة',
  'tour.departureCity': 'مدينة المغادرة',
  'tour.departureCountry': 'بلد المغادرة',
  'tour.en.departure': 'المغادرة',
  'tour.en.fa.departure': 'المغادرة بالفارسية',
  'tour.difficultyRate': 'صعوبة السفر',
  'tour.departureDate': 'وقت بدء الجولة',
  'tour.international': 'دولي',
  'tour.domestic': 'محلي',
  'tour.addTour': 'إضافة جولة جديدة',
  'tour.easy': 'سهل',

  'tour.amature': 'هاوی',
  'tour.normal': 'عادی',
  'tour.hard': 'سخت',
  'tour.veryHard': 'خیلی سخت',
  'tour.road': 'جاده',
  'tour.flight': 'پرواز',
  'tour.marine': 'دریایی',
  'tour.transportTypes': 'انواع حمل و نقل',
  'tour.chooseTransportTypes': 'انتخاب انواع حمل و نقل',
  'tour.surpriseTour': 'تور غافلگیرانه',
  'tour.ordinaryTour': 'تور عادی',
  'tour.next': 'مرحله بعدی',
  'tour.home': 'خانه',
  'tour.confirm': 'تایید',
  'tour.previous': 'مرحله قبلی',
  'tour.active': 'فعال',
  'tour.disable': 'غیرفعال',
  'tour.dollar': 'دلار آمریکا',
  'tour.euro': 'یورو',
  'tour.rial': 'ریال',
  'tour.stepOne': 'مرحله 1',
  'tour.stepTwo': 'مرحله 2',
  'tour.stepThree': 'مرحله 3',
  'tour.stepFour': 'مرحله 4',
  'tour.stepFive': 'مرحله 5',
  'tour.details': 'جزئیات',
  'tour.tourDetails': 'جزئیات تور',
  'tour.cancel': 'انصراف',
  'tour.chooseTourType': 'انتخاب نوع تور',
  'tour.save': 'ذخیره',
  'tour.tourDetail': 'اطلاعات تور',
  'tour.furtherInformation': 'اطلاعات بیشتر',
  'tour.toddlerinownsitPrice': 'قیمت برای کودک در صندلی خودش',
  'tour.infantPrice': 'قیمت برای نوزاد',
  'tour.childPrice': 'قیمت برای کودک',
  'tour.adultPrice': 'قیمت برای بزرگسال',
  'tour.studentPrice': 'قیمت برای دانشجو',
  'tour.seniorcitizenPrice': 'قیمت برای سالمندان',
  'tour.bookingDeadline': 'مهلت ثبت‌نام برای تور',
  'tour.climateType': 'وضعیت آب و هوا در طول سفر',
  'tour.step': 'مرحله',
  'tour.tourclimateTitle': 'انتخاب آب و هوای تور',
  'tour.tourclimateDescription': 'نوع آب و هوای مورد نظر خود را انتخاب کنید',
  'tour.tourtypeTitle': 'انتخاب نوع تور',
  'tour.tourtypeDescription': 'نوع تور مورد نظر خود را انتخاب کنید',
  'tour.tourtransfertypeTitle': 'نوع حمل و نقل تور',
  'tour.tourtransfertypeDescription':
    'نوع حمل و نقل تور مورد نظر خود را انتخاب کنید',
  'tour.tourpassengertypeTitle': 'نوع مسافران تور',
  'tour.tourpassengertypeDescription':
    'نوع مسافران تور مورد نظر خود را انتخاب کنید',
  'tour.tourinformationTitle': 'اطلاعات تور',
  'tour.tourinformationDescription': 'اطلاعات کامل تور خود را وارد کنید',
  'tour.touroverviewTitle': 'بررسی اجمالی تور',
  'tour.touroverviewDescription':
    'اطلاعات تور خود را مرور کنید و در صورت لزوم ویرایش کنید',
  'tour.tourpriceTitle': 'قیمت تور',
  'tour.overview': 'بررسی اجمالی',
  'tour.tourpriceDescription':
    'قیمت‌گذاری برای هر مسافر انتخابی خود را وارد کنید',
  'tour.tourScheduling': 'برنامه‌ریزی تور',
  'tour.mainTourInformation': 'اطلاعات اصلی تور',
  'tour.tourConditions': 'شرایط تور',
  'tour.tourRestrictionsRequirements': 'محدودیت‌ها و الزامات تور',
  'tour.tourRegistration': 'ثبت‌نام تور',
  'tour.addNewTour': 'افزودن تور جدید',
  'tour.tourInformationTemporarilyRecorded': 'تم تسجيل معلومات الجولة مؤقتاً.',
  'tour.yourTourSuccessfullyRegistered': 'تم تسجيل جولتك بنجاح.',
  'tour.tourInformationTemporarilyRecorded': 'تم تسجيل معلومات الجولة مؤقتًا.',
  'tour.yourTourSuccessfullyRegistered': 'تم تسجيل جولتك بنجاح.',

  'tour.tourpassengertype': 'نوع المسافر',
  'tour.tourtransfertype': 'نوع جولة النقل',
  'tour.tourType': 'نوع الجولة',
  'tour.nameen': 'اسم الجولة (بالإنجليزية)',
  'tour.namefa': 'اسم الجولة (بالفارسية)',
  'tour.bookingDeadLine': 'آخر موعد للتسجيل في الجولة',
  'tour.climateTypes': 'أنواع مناخ الجولة',
  'tour.limitationsen': 'القيود على السفر (بالإنجليزية)',
  'tour.limitationsfa': 'القيود على السفر (بالفارسية)',
  'tour.necessitiesen': 'الضروريات اللازمة للسفر (بالإنجليزية)',
  'tour.necessitiesfa': 'الضروريات اللازمة للسفر (بالفارسية)',
  'tour.descriptionen': 'وصف الرحلة المطلوب (بالإنجليزية)',
  'tour.descriptionfa': 'وصف الرحلة المطلوب (بالفارسية)',
  'tour.tourpassengertype': 'نوع المسافر',
  'tour.tourtransfertype': 'نوع جولة النقل',
  'tour.tourType': 'نوع الجولة',
  'tour.nameen': 'اسم الجولة (بالإنجليزية)',
  'tour.namefa': 'اسم الجولة (بالفارسية)',
  'tour.bookingDeadLine': 'آخر موعد للتسجيل في الجولة',
  'tour.climateTypes': 'أنواع مناخ الجولة',
  'tour.limitationsen': 'القيود على السفر (بالإنجليزية)',
  'tour.limitationsfa': 'القيود على السفر (بالفارسية)',
  'tour.necessitiesen': 'الضروريات اللازمة للسفر (بالإنجليزية)',
  'tour.necessitiesfa': 'الضروريات اللازمة للسفر (بالفارسية)',
  'tour.descriptionen': 'وصف الرحلة المطلوب (بالإنجليزية)',
  'tour.descriptionfa': 'وصف الرحلة المطلوب (بالفارسية)',
  'tour.editTourTransferType': 'تحرير معلومات نقل الجولة',
  'tour.editTourPassengerType': 'تحرير معلومات وأسعار المسافرين لكل مسافر',
  'tour.editTourInformation': 'تحرير معلومات الجولة العامة',
  'tour.tourRegistration': 'تسجيل الجولة',
  'tour.isActive': 'النشاط',
  'tour.editTourPassengerType': 'تحرير نوع مسافر الجولة',
  'tour.editTourTransferType': 'تحرير نوع نقل الجولة',
  'tour.editTourInformationType': 'تحرير نوع معلومات الجولة',
  'tour.editTourPrice': 'تحرير سعر المسافر',
  'tour.attachments': 'المرفقات',
  'tour.cancelingRules': 'قواعد الإلغاء',
  'tour.editTourTransferType': 'تحرير معلومات نقل الجولة',
  'tour.editTourPassengerType': 'تحرير معلومات وأسعار المسافرين لكل مسافر',
  'tour.editTourInformation': 'تحرير معلومات الجولة العامة',
  'tour.tourRegistration': 'تسجيل الجولة',
  'tour.isActive': 'النشاط',
  'tour.editTourPassengerType': 'تحرير نوع مسافر الجولة',
  'tour.editTourTransferType': 'تحرير نوع نقل الجولة',
  'tour.editTourInformationType': 'تحرير نوع معلومات الجولة',
  'tour.editTourPrice': 'تحرير سعر المسافر',
  'tour.attachments': 'المرفقات',
  'tour.cancelingRules': 'قواعد الإلغاء',

  'tour.endBookingDeadLine': 'انتهاء الموعد النهائي للحجز',
  'tour.endPrice': 'السعر النهائي',
  'tour.startPrice': 'السعر الابتدائي',
  'tour.endDuration': 'مدة النهاية',
  'tour.startDuration': 'مدة البداية',
  'tour.endDepartureDate': 'تاريخ المغادرة النهائي',
  'tour.startDepartureDate': 'تاريخ المغادرة الابتدائي',
  'tour.tour': 'جولة',
  'tour.sortby': 'ترتيب حسب',
  'tour.search': 'بحث',
  'tour.nameoftour': 'اسم الجولة ...',
  'tour.price': 'السعر',
  'tour.type': 'النوع',
  'tour.selectdate': 'اختر تاريخ الجولة',
  'tour.newest': 'الأحدث',
  'tour.cheapest': 'الأرخص',
  'tour.lowestduration': 'أقصر مدة',
  'tour.highestduration': 'أطول مدة',
  'tour.all': 'الكل',
  'tour.more': 'المزيد من التفاصيل',
  'tour.irr': 'ريال إيراني',
  'tour.usd': 'دولار أمريكي',
  'tour.tourfound': 'الجولات الموجودة',
  'tour.origin': 'من',
  'tour.agerange': 'الفئة العمرية',
  'tour.date': 'التاريخ',
  'tour.operator': 'المشغل',
  'tour.necessities': 'الاحتياجات',
  'tour.reserve': 'احجز جولة',
  'tour.amazingtour': 'جولة رائعة',
  'tour.tourfrom': 'جولة من',
  'tour.difficultyrate': '(معدل الصعوبة)',
  'tour.measure': 'تقديم الفلتر',
  'tour.domesticName': 'اسم الجولة المحلية',
  'tour.count': 'عدد الأشخاص',
  'tour.originterminal': 'محطة الأصل',
  'tour.destinationterminal': 'محطة الوجهة',
  'tour.vehicletype': 'نوع المركبة',
  'tour.starttime': 'وقت البدء',
  'tour.endtime': 'وقت الانتهاء',
  'tour.invalidreturndate': 'تاريخ النهاية أقل من تاريخ البداية',
  'tour.invalidstartdate': 'تاريخ البداية أكبر من تاريخ النهاية',
  'tour.facilities': 'مرافق الجولة',
  'tour.invalidEndTime': 'وقت النهاية أقل من وقت البدء',
  'tour.drafts': 'مسودات',
  'tour.useprevioustours': 'استخدام الجولات السابقة',
  'tour.Draft': 'مسودات الجولات',
  'tour.creationDate': 'تاريخ الإنشاء',
  'tour.dateCreatedFrom': 'تاريخ الإنشاء من',
  'tour.dateCreatedUntil': 'تاريخ الإنشاء حتى',
  'tour.ordering': 'ترتيب',
  'tour.basedTourName': 'بناءً على اسم الجولة',
  'tour.basedNamePlace': 'بناءً على اسم المكان',
  'tour.search': 'بحث بالاسم والموقع',
  'tour.facilitynotdeclared': 'لم يتم تحديد المرفق',
  'tour.basicinfonotfound': 'لم يتم تحديد معلومات الجولة',
  'tour.finaldestination': 'الوجهة النهائية',
  'tour.insertdraft': 'إدراج المسودة',
  'tour.updatetdraft': 'تحديث المسودة',
  'tour.ageSuffering': 'معاناة العمر',
  'tour.finaldestination': 'الوجهة النهائية',
  'tour.insertsuccess': 'تم تسجيل الجولة بنجاح',
  'tour.draftinsertsuccess': 'تم تسجيل مسودة الجولة بنجاح',
  'tour.inserterror': 'فشل تسجيل الجولة',
  'tour.updatesuccess': 'تم تحديث الجولة بنجاح',
  'tour.draftupdatesuccess': 'تم تحديث مسودة الجولة بنجاح',
  'tour.updateerror': 'فشل تحديث الجولة',
  'tour.deletesuccess': 'تم حذف الجولة بنجاح',
  'tour.draftdeletesuccess': 'تم حذف مسودة الجولة بنجاح',
  'tour.deleteerror': 'فشل حذف الجولة',
  'tour.deletedrafttour': 'حذف مسودة الجولة',
  'tour.deletedrafttourmessage': 'هل أنت متأكد أنك تريد حذف مسودة الجولة؟',
  'tour.male': 'ذكر',
  'tour.female': 'أنثى',
  'tour.all': 'الكل',
  'tour.changefieldwarning':
    'إذا تم إجراء تغييرات في الحقول المهمة، سيتم حذف معلومات الخطوات التالية. انقر لمزيد من المعلومات',
  'tour.importantfieldsintroduction':
    'تطبيق تغييرات على الحقول التالية سيؤدي إلى فقدان البيانات في النماذج التالية',
  'tour.tournotspecified': 'لم يتم تحديد معلومات الجولة',
  'tour.stoptype': 'نوع التوقف',
  'tour.searchfacilities': 'بحث عن المرافق',
  'tour.confirmdata': 'تم التحقق من جميع المعلومات المسجلة',
  'tour.vehiclenamefa': 'اسم المركبة المحلي',
  'tour.vehiclenameen': 'اسم المركبة بالإنجليزية',
  'tour.transportproviderlocal': 'اسم مقدم النقل المحلي',
  'tour.transportprovideren': 'اسم مقدم النقل بالإنجليزية',
  'tour.addnewtourtype': 'إضافة نوع جولة جديد',
  'tour.submittourtype': 'تقديم نوع جولة جديد',
  'tour.tourtypenamefa': 'اسم نوع الجولة بالفارسية',
  'tour.tourtypenameen': 'اسم نوع الجولة بالإنجليزية',
  'tour.tourtypeinsertsuccess': 'تم الإدراج بنجاح',
  'tour.tourtypeinserterror': 'فشل في الإدراج',
  'tour.originairport': 'مطار المغادرة',
  'tour.destinationairport': 'مطار الوصول',
  'tour.arrivaldateto': 'تاريخ الوصول',
  'tour.arrivaltimeto': 'وقت الوصول',
  'tour.nextmovedate': 'تاريخ بدء النقل التالي',
  'tour.nextmovetime': 'وقت بدء النقل التالي',
  'tour.tourimages': 'صور الجولة',
  'tour.viewimages': 'عرض الصور',
  'tour.addnewtourfacility': 'إضافة مرافق جولة جديدة',
  'tour.tourfacilitynamefa': 'اسم مرافق الجولة بالفارسية',
  'tour.tourfacilitynameen': 'اسم مرافق الجولة بالإنجليزية',
  'tour.originterminalfa': 'الاسم المحلي لمحطة الانطلاق',
  'tour.originterminalen': 'الاسم الإنجليزي لمحطة الانطلاق',
  'tour.destinationterminalfa': 'الاسم المحلي لمحطة الوصول',
  'tour.destinationterminalen': 'الاسم الإنجليزي لمحطة الوصول',
  'tour.underreviewing': 'تحت المراجعة',
  'tour.expired': 'منتهية الصلاحية',
  'tour.residence': 'الإقامة',
  'tour.pricepercustomer': 'السعر لكل شخص',
  'tour.userstours': 'جولاتي',
  'tour.usersalltours': 'جميع الجولات',
  'tour.usersactivetours': 'الجولات النشطة',
  'tour.usersexpiredtours': 'الجولات المنتهية الصلاحية',
  'tour.changerequiredfields': 'عرض نتيجة مراجعة المشغل',
  'tour.requiredreviews': 'المراجعات المطلوبة',
  'tour.rejectionreason': 'سبب الرفض',
  'tour.rejectiondescription': 'وصف الرفض',
  'tour.starttime': 'وقت البدء',
  'tour.endtime': 'وقت الانتهاء',
  'tour.imageuploadfailed': 'فشل تحميل الصورة',
};
